import React, { useState, useEffect } from 'react';
import EstacionInput from '../../../components/EstacionInput';
import { locomotorasService } from '../../../services/api';

const TRAMO_VACIO = { hora_inicio: '', estacion_inicio: '', hora_fin: '', estacion_fin: '', descripcion: '', km_realizados: '', horas_efectivas: '', horas_disposicion: '' };

export default function ParteTrabajoForm({ locoId, inicial, kmInicio, onGuardar, onVolver }) {
  const init = inicial || {};
  const [loco, setLoco] = useState(null);
  const [tramos, setTramos] = useState(init.tramos || [{ ...TRAMO_VACIO, orden: 1 }]);
  const [observaciones, setObservaciones] = useState(init.observaciones || '');
  const [kmFin, setKmFin] = useState(init.km_fin || '');

  useEffect(() => {
    if (!locoId) return;
    locomotorasService.getAll().then(r => {
      const l = r.data.find(l => l.id === locoId);
      if (l) setLoco(l);
    });
  }, [locoId]);

  const kmServicioCalculado = kmFin && kmInicio ? Math.max(0, parseFloat(kmFin) - parseFloat(kmInicio)) : null;
  const kmTotalesTramos = tramos.reduce((s, t) => s + (parseFloat(t.km_realizados) || 0), 0);

  const updateTramo = (idx, field, value) => {
    const nuevos = [...tramos];
    nuevos[idx] = { ...nuevos[idx], [field]: value };
    if (field === 'hora_inicio' || field === 'hora_fin') {
      const t = nuevos[idx];
      if (t.hora_inicio && t.hora_fin) {
        const [h1, m1] = t.hora_inicio.split(':').map(Number);
        const [h2, m2] = t.hora_fin.split(':').map(Number);
        const mins = (h2 * 60 + m2) - (h1 * 60 + m1);
        if (mins > 0) nuevos[idx].horas_efectivas = (mins / 60).toFixed(2);
      }
    }
    setTramos(nuevos);
  };

  const guardar = () => {
    if (!tramos[0].hora_inicio || !tramos[0].estacion_inicio) {
      alert('Rellena al menos el primer tramo'); return;
    }
    onGuardar({
      observaciones,
      km_fin: kmFin ? parseFloat(kmFin) : null,
      km_servicio: kmServicioCalculado,
      tramos: tramos.filter(t => t.hora_inicio).map((t, i) => ({
        orden: i + 1,
        hora_inicio: t.hora_inicio,
        estacion_inicio: t.estacion_inicio,
        hora_fin: t.hora_fin,
        estacion_fin: t.estacion_fin,
        km_realizados: parseFloat(t.km_realizados) || 0,
        horas_efectivas: parseFloat(t.horas_efectivas) || 0,
        horas_disposicion: parseFloat(t.horas_disposicion) || 0,
        descripcion: t.descripcion || '',
      }))
    });
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '16px', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <button onClick={onVolver} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 14 }}>←</button>
        <div>
          <h1 style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>Parte de trabajo</h1>
          <p style={{ fontSize: 12, color: '#888', margin: '2px 0 0' }}>{loco?.numero}</p>
        </div>
      </div>

      {tramos.map((t, i) => (
        <div key={i} style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 16, marginBottom: 12 }}>
          <div style={{ fontSize: 13, fontWeight: 500, color: '#555', marginBottom: 10 }}>Tramo {i + 1}</div>
          <div style={{ marginBottom: 10 }}>
            <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Descripcion del trabajo</label>
            <input value={t.descripcion} onChange={e => updateTramo(i, 'descripcion', e.target.value)}
              placeholder="Ej: Exploracion MDC - Alicante"
              style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Hora inicio</label>
              <input type="time" value={t.hora_inicio} onChange={e => updateTramo(i, 'hora_inicio', e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Estacion inicio</label>
              <EstacionInput value={t.estacion_inicio} onChange={v => updateTramo(i, 'estacion_inicio', v)} />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Hora fin</label>
              <input type="time" value={t.hora_fin} onChange={e => updateTramo(i, 'hora_fin', e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Estacion fin</label>
              <EstacionInput value={t.estacion_fin} onChange={v => updateTramo(i, 'estacion_fin', v)} />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>KM realizados</label>
              <input type="number" value={t.km_realizados} onChange={e => updateTramo(i, 'km_realizados', e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>H. efectivas</label>
              <input type="number" value={t.horas_efectivas} onChange={e => updateTramo(i, 'horas_efectivas', e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>H. disposicion</label>
              <input type="number" value={t.horas_disposicion} onChange={e => updateTramo(i, 'horas_disposicion', e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
            </div>
          </div>
        </div>
      ))}

      {tramos.length < 3 && (
        <button onClick={() => setTramos([...tramos, { ...TRAMO_VACIO, orden: tramos.length + 1 }])}
          style={{ width: '100%', padding: '12px', borderRadius: 10, border: '1px dashed #ddd', background: '#fff', color: '#555', fontSize: 14, cursor: 'pointer', marginBottom: 12 }}>
          + Añadir tramo
        </button>
      )}

      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 16, marginBottom: 12 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, alignItems: 'end' }}>
          <div>
            <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>KM odometro fin locomotora</label>
            <input type="number" value={kmFin} onChange={e => setKmFin(e.target.value)}
              placeholder="KM totales al acabar"
              style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14 }} />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>KM realizados en el servicio</label>
            {kmServicioCalculado !== null ? (
              <div style={{ padding: '10px', borderRadius: 8, background: '#eaf3de', border: '1px solid #97c459', fontSize: 14, color: '#3b6d11', fontWeight: 600 }}>
                {kmServicioCalculado.toFixed(0)} km ✓
              </div>
            ) : (
              <div style={{ padding: '10px', borderRadius: 8, background: '#f8f8f6', border: '1px solid #e5e5e5', fontSize: 14, color: '#aaa' }}>
                Introduce KM fin
              </div>
            )}
          </div>
        </div>
        {kmTotalesTramos > 0 && (
          <div style={{ marginTop: 10, fontSize: 12, color: '#888' }}>
            Suma KM tramos: {kmTotalesTramos.toFixed(0)} km
          </div>
        )}
      </div>

      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 16, marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 6 }}>Observaciones del servicio</label>
        <textarea value={observaciones} onChange={e => setObservaciones(e.target.value)} rows={3}
          placeholder="Observaciones..."
          style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, resize: 'none', boxSizing: 'border-box' }} />
      </div>

      <button onClick={guardar} style={{ width: '100%', padding: '16px', borderRadius: 12, border: 'none', background: '#1a1a1a', color: '#fff', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>
        Guardar parte de trabajo
      </button>
    </div>
  );
}
